import React, { useState, useEffect } from 'react'
import Loader from '../../../components/Loader'
import Image from '../../../components/Image'
import { getProductImage } from '../../../lib/commonlyused'
import { getSession } from '../../../lib/auth'
import API from '../../../lib/api'
import { FE_GATEWAY_API_URL } from '../../../config/app'
import './swimlanepreview.css'

const SwimlanePreview = ({ values,selectionData }) => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState(null)
  const [isCurrent, setIsCurrent] = useState(false)

  useEffect(() => {
    const fetchPreviewData = () => {
      setLoading(true)

      // Determine collection type and get slug
      let collectionType = ''
      let collectionSlug = ''
      let pageType = ''
      let tagParam = ''

      // Check if collection type is CURRENT and if selectionData has the value
      let isCurrentTag = values.tag && (values.tag === 'CURRENT' || (typeof values.tag === 'object' && values.tag.slug === 'CURRENT'))
      let isCurrentCategory = values.category && (values.category === 'CURRENT' || (typeof values.category === 'object' && values.category.slug === 'CURRENT'))
      let isCurrentBrand = values.brand && (values.brand === 'CURRENT' || (typeof values.brand === 'object' && values.brand.slug === 'CURRENT'))

      // If CURRENT, check selectionData first
      if (isCurrentTag && selectionData?.tag) {
        // Use selectionData.tag if available
        const tag = typeof selectionData.tag === 'object' ? selectionData.tag : { slug: selectionData.tag }
        collectionType = 'tag'
        pageType = 'tag'
        collectionSlug = tag.slug || selectionData.tag
        tagParam = tag.slug || selectionData.tag
        isCurrentTag = false
      } else if (isCurrentCategory && selectionData?.category) {
        // Use selectionData.category if available
        const category = typeof selectionData.category === 'object' ? selectionData.category : { slug: selectionData.category }
        collectionType = 'category'
        pageType = 'category'
        collectionSlug = category.slug || selectionData.category
        isCurrentCategory = false
      } else if (isCurrentBrand && selectionData?.brand) {
        // Use selectionData.brand if available
        const brand = typeof selectionData.brand === 'object' ? selectionData.brand : { slug: selectionData.brand }
        collectionType = 'brand'
        pageType = 'brand'
        collectionSlug = brand.slug || selectionData.brand
        isCurrentBrand = false
      }

      // If still CURRENT and no selectionData, show message
      if (isCurrentTag || isCurrentCategory || isCurrentBrand) {
        setIsCurrent(true)
        setLoading(false)
        return
      }

      setIsCurrent(false)

      // Use values if not CURRENT or if selectionData was used above
      if (!collectionType) {
        if (values.tag && values.tag !== 'ALL' && values.tag !== 'CURRENT') {
          const tag = typeof values.tag === 'object' ? values.tag : { slug: values.tag }
          collectionType = 'tag'
          pageType = 'tag'
          collectionSlug = tag.slug || values.tag
          tagParam = tag.slug || values.tag
        } else if (values.category && values.category !== 'ALL' && values.category !== 'CURRENT') {
          const category = typeof values.category === 'object' ? values.category : { slug: values.category }
          collectionType = 'category'
          pageType = 'category'
          collectionSlug = category.slug || values.category
        } else if (values.brand && values.brand !== 'ALL' && values.brand !== 'CURRENT') {
          const brand = typeof values.brand === 'object' ? values.brand : { slug: values.brand }
          collectionType = 'brand'
          pageType = 'brand'
          collectionSlug = brand.slug || values.brand
        }
      }

      // Extract other variables from values
      const title = values.title || ''
      const subtitle = values.subtitle || ''
      const sorting = values.sorting || 'POPULARITY'
      const source = values.source || 'SEEALL'
      const sourcePage = values.sourcePage || 'HOME'
      const orderType = values.orderType || 'DELIVERY'

      // Static/default parameters
      const algopers = 'prm-ppb-0,t-epds-1'
      const ctaSublocation = title
      const experiments =
        'ls_deltime-sortA,searchVariant-A,gv-B,smartrecommender-a,shelflife-A,ds-B,ls_comsl-B,cartfiller-b,catnav-show,catbubog-B,sbanner-A,cam-a,promobanner-c,algopers-a,dlv_pref_mf-B,delivery_pref_ffs-C,delivery_pref_pfc-C,crtalc-B,rec-wtyl-dy,rec-fbt-dy,rec-cat-dy,rec-pdbn-dy,rec-ws-dy,rec-bs-dy,rec-whn-dy,rec-ne-dy,rec-wfp-dy,rec-tag-ds,sd-var-c,cosmos-on,gsc-a,camp-lbl-A,poa-entry-A,substitutionVariant-B,substitutionVariant-B,substitutionVariant-B,rec-fbt-dy'
      const includeTagDetails = 'true'
      const metaData = '[object Object]'
      const url = collectionSlug

      // Build query parameters
      const queryParams = new URLSearchParams({
        algopers,
        collectionSlug,
        collectionType,
        ctaSublocation,
        experiments,
        includeTagDetails,
        metaData,
        orderType,
        pageType,
        sorting,
        source,
        sourcePage,
        subtitle,
        title,
        url,
      })

      // Add tag parameter if it's a tag collection
      if (tagParam) {
        queryParams.append('tag', tagParam)
      }

      // Only make API call if we have a valid collectionType
      if (!collectionType || !collectionSlug) {
        setLoading(false)
        return
      }

      const apiUrl = `${FE_GATEWAY_API_URL}/product/v2?${queryParams.toString()}`

      // Use API class for external URL
      const api = new API({ url: apiUrl })
      api
        .get()
        .then((response) => {
          setData(response)
          setLoading(false)
        })
        .catch((error) => {
          console.error('Error fetching preview data:', error)
          setLoading(false)
        })
    }

    fetchPreviewData()
  }, [values, selectionData])

  if (loading) {
    return <Loader />
  }

  if (isCurrent) {
    return (
      <div className="swimlane-preview-empty">
        Preview feature is not available for default layout product swimlane
      </div>
    )
  }

  if (!data?.data?.product) {
    return (
      <div className="swimlane-preview-empty">
        No products found
      </div>
    )
  }

  const isHorizontalCard =
    values.layoutType === 'SCROLLER' && values.loadMoreType === 'SEEALL'
  const isVerticalCardInScroll =
    values.layoutType === 'GRID' && values.loadMoreType === 'SEEALL'

  return (
    <div className="swimlane-preview">
      {/* Title and Subtitle Section */}
      <div className="swimlane-preview-header">
        <div>
          {values.title && (
            <h2 className="swimlane-preview-title">
              {values.title}
            </h2>
          )}
          {values.subtitle && (
            <p className="swimlane-preview-subtitle">
              {values.subtitle}
            </p>
          )}
        </div>
        {values.loadMoreType === 'SEEALL' && (
          <a
            href="#"
            onClick={(e) => e.preventDefault()}
            className="swimlane-preview-see-all"
          >
            See all
          </a>
        )}
      </div>
      {/* Product Container - Grid or Horizontal Scroll */}
      <div
        className={
          values.loadMoreType === 'INFINITE' &&
          values.layoutType === 'GRID'
            ? 'swimlane-preview-container-grid'
            : 'swimlane-preview-container-scroll'
        }
      >
        {data.data.product.map((product) => (
          <div
            key={product.id}
            className={
              isHorizontalCard
                ? 'swimlane-preview-card-horizontal'
                : isVerticalCardInScroll
                  ? 'swimlane-preview-card-vertical-scroll'
                  : 'swimlane-preview-card-vertical-grid'
            }
          >
            {isHorizontalCard ? (
              <>
                <div className="swimlane-preview-image-container">
                  <Image
                    src={getProductImage(product)}
                    size="md"
                    bordered
                  />
                </div>
                <div className="swimlane-preview-content">
                  <div>
                    <div className="swimlane-preview-price">
                      {getSession().organization?.currency?.symbol || '$'}
                      {product.final_price?.toFixed(2) || '0.00'}
                    </div>
                    <div className="swimlane-preview-name">
                      {product.brand && (
                        <span className="swimlane-preview-brand">
                          {product.brand.name}{' '}
                        </span>
                      )}
                      {product.name}
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={(e) => e.preventDefault()}
                    className="swimlane-preview-button-horizontal"
                  >
                    Add to cart
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className="swimlane-preview-image-wrapper">
                  <Image
                    src={getProductImage(product)}
                    size="md"
                    bordered
                  />
                </div>
                <div className="swimlane-preview-price">
                  {getSession().organization?.currency?.symbol || '$'}
                  {product.final_price?.toFixed(2) || '0.00'}
                </div>
                <div className="swimlane-preview-name-vertical">
                  {product.brand && (
                    <span className="swimlane-preview-brand">
                      {product.brand.name}{' '}
                    </span>
                  )}
                  {product.name}
                </div>
                <button
                  type="button"
                  onClick={(e) => e.preventDefault()}
                  className="swimlane-preview-button"
                >
                  Add to cart
                </button>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default SwimlanePreview

